import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconEvents = (props) => {
  props = Object.assign({viewBox: '0 0 36 36'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <path d="M7.8,22.8v3.9h4.1v-3.9H7.8z M10.8,25.6h-2v-1.8h2V25.6z"/>
          <path d="M13.2,22.8v3.9h4.1v-3.9H13.2z M16.3,25.6h-2v-1.8h2V25.6z"/>
          <path d="M18.7,22.8v3.9h4.1v-3.9H18.7z M21.7,25.6h-2v-1.8h2V25.6z"/>
          <path d="M24.1,22.8v3.9h4.1v-3.9H24.1z M27.2,25.6h-2v-1.8h2V25.6z"/>
          <path d="M7.8,16.9v3.9h4.1v-3.9H7.8z M10.8,19.8h-2V18h2V19.8z"/>
          <path d="M13.2,16.9v3.9h4.1v-3.9H13.2z M16.3,19.8h-2V18h2V19.8z"/>
          <path d="M18.7,16.9v3.9h4.1v-3.9H18.7z M21.7,19.8h-2V18h2V19.8z"/>
          <path d="M24.1,16.9v3.9h4.1v-3.9H24.1z M27.2,19.8h-2V18h2V19.8z"/>
          <path d="M13.2,11.5v3.9h4.1v-3.9H13.2z M16.3,14.3h-2v-1.8h2V14.3z"/>
          <path d="M7.8,11.5v3.9h4.1v-3.9H7.8z M10.8,14.3h-2v-1.8h2V14.3z"/>
          <path d="M18.7,11.5v3.9h4.1v-3.9H18.7z M21.7,14.3h-2v-1.8h2V14.3z"/>
          <path d="M24.1,11.5v3.9h4.1v-3.9H24.1z M27.2,14.3h-2v-1.8h2V14.3z"/>
        </g>
        <rect x="10.2" y="5.3" width="1.1" height="4.9"/>
        <rect x="25.2" y="5.3" width="1.1" height="4.9"/>
        <g>
          <rect x="12.6" y="7.5" width="11.2" height="1.1"/>
          <polygon points="27.8,7.5 27.8,8.6 30.9,8.6 30.9,29.6 5.1,29.6 5.1,8.6 8.8,8.6 8.8,7.5 4,7.5 4,30.7 32,30.7 32,7.5"/>
        </g>
      </g>
    </SvgIcon>
  );
};

IconEvents.displayName = 'IconEvents';
IconEvents.muiName = 'SvgIcon';

export default IconEvents;



// WEBPACK FOOTER //
// ./src/components/Icons/IconEvents.js